import React, { BaseSyntheticEvent } from 'react';

export const getHandlerKayPress = (key: string, cb: (e: React.KeyboardEvent) => void) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === key) {
      cb(e);
    }
  };
};

export const handlerStop = (e: BaseSyntheticEvent) => {
  e.stopPropagation();
};

export const handlerStopAndPrevent = (e: BaseSyntheticEvent) => {
  e.stopPropagation();
  e.preventDefault();
};
